<template>
    <div class="box-shadow box-shadow--big">
        <div class="helper__wrapper">
            <h5 class="mb-3">{{ $t('SPECIFY_SCAR_TYPE') }}</h5>

            <div class="flex-row">
                <label class="fake-label" style="vertical-align: top">
                    <input
                        class="custom-input"
                        type="radio"
                        value="OPARZENIE"
                        @change="updateType(false)"
                        name="scars-on-breast"
                        v-model="s3q7_typeVal"
                    />
                    <span class="input-container">{{ $t('BURN') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label" style="vertical-align: top">
                    <input
                        class="custom-input"
                        type="radio"
                        value="URAZ"
                        @change="updateType(false)"
                        name="scars-on-breast"
                        v-model="s3q7_typeVal"
                    />
                    <span class="input-container">{{ $t('INJURY') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label" style="vertical-align: top">
                    <input
                        class="custom-input"
                        type="radio"
                        value="INNY"
                        @change="updateType(true)"
                        name="scars-on-breast"
                        v-model="s3q7_typeVal"
                    />
                    <span class="input-container">{{ $t('OTHER_WHAT') }}</span>
                    <span class="checkmark"></span>
                </label>

                <input
                    v-if="showValueInput"
                    :placeholder="$t('INSERT_TYPE')"
                    type="text"
                    style="margin-left: auto"
                    class="el-input__inner el-input__inner--small"
                    v-model="s3q7_typeDescription"
                    @change="updateTypeDescription()"
                />
            </div>

            <h5 class="mb-3">{{ $t('SPECIFY_SIZE_AND_LOCATION') }}</h5>

            <div class="col-xs-12 col-sm-8 el-col-sm-offset-4 mt-3 mb-4">
                <el-input
                    type="textarea"
                    :rows="5"
                    :placeholder="$t('INSERT_DOTS')"
                    v-model="s3q7_description"
                    @change="updateDescription"
                >
                </el-input>
            </div>

            <div class="text-center mt-0 mb-3 mr-3">
                <button class="w160 app-btn app-btn--small app-btn-primary">
                    {{ $t('SAVE') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.s3q7_typeVal = this.$store.getters.survey.section3.q7_type;
        this.s3q7_typeDescription = this.$store.getters.survey.section3.q7_type;
        this.s3q7_description = this.$store.getters.survey.section3.q7_description;
        if (this.s3q7_typeVal != 'OPARZENIE' && this.s3q7_typeVal != 'URAZ' && this.s3q7_typeVal) {
            this.s3q7_typeVal = 'INNY';
            this.showValueInput = true;
        }
    },
    data() {
        return {
            s3q7_typeVal: this.q7_type,
            s3q7_typeDescription: this.q7_type,
            showValueInput: false,
            s3q7_description: this.q7_description,
        };
    },
    computed: {
        q7_type() {
            return this.$store.getters.survey.section3.q7_type;
        },
        q7_description() {
            return this.$store.getters.survey.section3.q7_description;
        },
    },
    methods: {
        updateType(showValueInput) {
            this.showValueInput = showValueInput;
            if (showValueInput == false) {
                this.$store.commit('STATE_SURVEY', {
                    section3: {
                        ...this.$store.getters.survey.section3,
                        q7_type: this.s3q7_typeVal,
                    },
                });
            }
            this.$emit('clicked');
        },
        updateTypeDescription() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q7_type: this.s3q7_typeDescription,
                },
            });
        },
        updateDescription() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q7_description: this.s3q7_description,
                },
            });
        },
    },
};
</script>

<style>
.select-img-container {
    background-size: contain;
    border: 1px solid #f1eeea;
    border-radius: 50px;
    box-sizing: border-box;
    display: block;
    margin: 30px auto;
    padding: 20px;
    text-align: center;
    /*max-width: 375px;*/
    /*width: 100%;*/
    cursor: url('/src/assets/images/select-cursor.cur'), text;
}

.select-img-container.right-breast {
    background: url('/src/assets/images/right-breast-shape.svg') center center no-repeat;
}

.select-img-container.left-breast {
    background: url('/src/assets/images/left-breast-shape.png') center center no-repeat;
}
</style>



// WEBPACK FOOTER //
// scars-on-breast.vue?7ea6570c